
import { defineComponent, PropType } from "vue"
import draggable from "vuedraggable"
import { Frame } from "@/js/types/service"

export default defineComponent({
    name: "DashboardNavbar",
    components: { draggable },
    props: {
        openedFrames: {
            type: Array as PropType<Frame[]>,
            required: true,
        },
        openedTab: {
            type: Number,
            required: true,
        },
    },
    emits: ["tab-click", "tab-close", "update-order"],
    computed: {
        frames: {
            get(): Frame[] {
                // @ts-ignore
                return this?.openedFrames
            },
            set(value: Frame[]) {
                this.$emit("update-order", value)
            },
        },
    },
    watch: {
        openedTab(tabIndex) {
            setTimeout(() => {
                if (!Number.isFinite(tabIndex)) return

                const tab = this.openedFrames[tabIndex]

                if (this.$refs["tabs-wrapper"]) {
                    // @ts-ignore
                    const tabEl = this.$refs["tabs-wrapper"]?.$el?.querySelector(
                        'li[data-id="' + tab.id + '"]',
                    )

                    if (tabEl) {
                        tabEl?.scrollIntoView()
                    }
                }
            }, 10)
        },
    },
})
